import { Shape } from 'src/theme/types';

export const shapes: Shape = {
  borderRadiusXxs: 4,
  borderRadiusXs: 8,
  borderRadiusSm: 16,
  borderRadiusMd: 32,
  borderRadius: 48
};
